import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "statistic";

export const useStatisticStore = defineStore(storeName, () => {
  const all = ref([]);
  const { baseFetchAll, watchRemoteResourceChange } = useBase(storeName);

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("statistics", errorCallback);
  };

  onMounted(async () => {
    await watchRemoteResourceChange("statistic", () => {
      fetchAll();
    });
  });

  return {
    all,
    stats: all,
    fetchAll,
  };
});
